import {
  useHover
} from "./chunk-Z4WFRWXY.mjs";

// lib/components/sort-handle/sort-handle/sort-handle.tsx
import classNames from "classnames";
import React from "react";
import { jsx } from "@emotion/react/jsx-runtime";
var SortHandle = React.forwardRef(
  ({
    style,
    className,
    small,
    thin,
    disabled,
    grabbing,
    onMouseEnter,
    onMouseLeave,
    ...props
  }, ref) => {
    const { hovering, hoverSensor } = useHover();
    return /* @__PURE__ */ jsx(
      "button",
      {
        ...props,
        ref,
        tabIndex: -1,
        className: classNames("button", className, small && "is-small"),
        style: {
          ...style,
          border: "none",
          background: grabbing || hovering ? "#F2F3F4" : "inherit",
          cursor: grabbing ? "grabbing" : !disabled ? "grab" : "not-allowed",
          boxShadow: grabbing ? "2px 2px 4px rgba(0, 14, 26, 0.1)" : void 0,
          paddingRight: thin ? "0.5em" : void 0,
          paddingLeft: thin ? "0.5em" : void 0
        },
        onMouseEnter: (e) => {
          hoverSensor.onMouseEnter(e);
          onMouseEnter?.(e);
        },
        onMouseLeave: (e) => {
          hoverSensor.onMouseLeave(e);
          onMouseLeave?.(e);
        },
        children: /* @__PURE__ */ jsx("span", { className: "icon", children: /* @__PURE__ */ jsx("i", { className: "fas fa-grip-vertical" }) })
      }
    );
  }
);
SortHandle.displayName = "SortHandle";

export {
  SortHandle
};
